<!--  Copyright (c) 2021 Proto Labs, Inc. All Rights Reserved. -->

<template>
	<snackbar-comp
		v-if="success"
		top
		v-model="toast.show"
		:color="toast.color"
		:timeout="toast.timer"
		multi-line
	>
		<slot />
	</snackbar-comp>
	<snackbar-comp
		v-else
		bottom
		v-model="toast.show"
		:color="toast.color"
		:timeout="toast.timer"
		multi-line
	>
		<slot />
	</snackbar-comp>
</template>

<script>
import { mapState } from 'vuex';
import { SnackbarComp } from '@protolabs/component-library';

export default {
	name: 'snackbar-status',
	components: {
		SnackbarComp,
	},
	props: {
		success: {
			required: true,
			type: Boolean,
		},
	},
	computed: {
		...mapState({
			toast: (state) => state.toast,
		}),
	},
};
</script>
